import { useDispatch } from 'react-redux';
import {
	Col,
	Alert,
	Spinner,
	Row,
	Card,
	CardHeader,
	CardBody,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getCompanyList } from '../../../slices/thunks';
import { Link } from 'react-router-dom';
import AddEditCompanyModal from './Add_Edit/AddEditCompaniesModal';
import DeleteCompanyModal from './Delete/DeleteCompany';
import { getRolesList } from '../../../slices/thunks';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';

const CompaniesList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorCompanies = createSelector(
		state => state.Companies,
		company => ({
			companyList: company.companyList,
			isLoadingList: company.isLoadingList,
			isCompanySuccess: company.isCompanySuccess,
			error: company.error,
			isAdding: company.isAdding,
			isAdded: company.isAdded,
			isAddError: company.isAddError,
			isUpdating: company.isUpdating,
			isUpdated: company.isUpdated,
			isUpdateError: company.isUpdateError,
			isDeleting: company.isDeleting,
			isDeleted: company.isDeleted,
			isDeleteError: company.isDeleteError,
		})
	);

	// const selectRolesList = createSelector(
	// 	state => state.Roles.roleListSelect,
	// 	roleListSelect => roleListSelect
	// );

	// const roleListSelect = useSelector(selectRolesList);

	const { companyList, isLoadingList } = useSelector(selectorCompanies);

	useEffect(() => {
		dispatch(getCompanyList());
	}, []);

	const [dataCompany, setDataCompany] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete Company
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = company => {
		setDataCompany(company);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = company => {
		setDataCompany(company);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'company',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const companyData =
														cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(companyData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const companyData =
														cellProps.row.original;
													handleClickDelete(companyData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{ header: 'RUT', accessorKey: 'rut',  size: 'auto' },
			{
				header: 'Nombre',
				accessorKey: 'name',
				
				size: 'auto',
			},
			{
				header: 'Sigla',
				accessorKey: 'initials',
				
				size: 'auto',
			},
			{
				header: 'Correo electrónico',
				accessorKey: 'email',
				
				size: 'auto',
			},
			{
				header: 'Fono',
				accessorKey: 'phono',
				
				size: 'auto',
			},
			{
				header: 'Dirección',
				accessorKey: 'address',
				
				size: 'auto',
			},
			{
				header: 'Holding',
				accessorKey: 'holding_company.name',
				
				size: 'auto',
				dataType: 'multi-select',
			},
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataCompany({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Empresa
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								data={companyList || []}
								isLoadingData={isLoadingList}
								nameFile={'empresa'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
												setIsEdit(false);
												setDataCompany({});
												handleToggleModal();
											},
										title: 'Crear Empresa',
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditCompanyModal
				dataCompany={dataCompany}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteCompanyModal
				dataCompany={dataCompany}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default CompaniesList;
